import React from 'react'
import {prepSigilMeta} from '../common/components/team_sigil'

const TeamSigil = (team, sigilMeta) => {
    const teamSigil = prepSigilMeta(team, sigilMeta)
    if (!teamSigil) {
        return
    }
    return (
        <span className="team-sigil" style={{ backgroundColor: teamSigil.color }}>
            {teamSigil.img ? <img src={teamSigil.img} alt={teamSigil.name} /> : <p className="team-sigil-name">{teamSigil.name}</p>}
        </span>
    )
}

export {
    TeamSigil as default,
}


// WEBPACK FOOTER //
// ./src/components/team_sigil.jsx